import OrganizationError from "@/lib/organization/error/OrganizationError";

export default class NoPrimaryClinicError extends OrganizationError
{

}
